import Segmento from './segmento'
import NCM from './ncm'

export default class CEST {
  constructor(id, codigo, descricao, dataInicio, dataFim) {
    this.id = id
    this.codigo = codigo
    this.descricao = descricao
    this.segmento = new Segmento()
    this.dataInicio = dataInicio
    this.dataFim = dataFim
    this.ncm = new NCM()
  }
}
